import { useState } from "react";
import { toast } from "react-toastify";

import {
  getPresignedS3Service,
  uploadToS3Service,
} from "../../fetch/services/general.services";
const useFileUpload = () => {
  const [isLoading, setIsLoading] = useState(false);
  type typeFile = "documents" | "locations" | "evses" | "reports" | "brand_models";

  const handleUpload = async (
    file: File | null,
    key: typeFile,
    userId: number | string,
    approvalId?: string,
    options?: { useOriginalName?: boolean }
  ) => {

    setIsLoading(true);
    try {
      if (file) {
          const presigned: any = await getPresignedS3Service(
          key,
          String(userId),
          options?.useOriginalName ? file.name : getName(key, Boolean(approvalId)),
          getType(file.type),
          "put_object",
          approvalId,
          true, // raw: queremos también la key
          options?.useOriginalName
        );



        if (!presigned) throw new Error("Ocurrio un error al obtener la URL");
        const data = await uploadToS3Service(presigned.data, file);
        if (data) {
          toast.success(`Archivo ${file.name} subido exitosamente`);
          return presigned.key as string | undefined;
        }
      }
    } catch (error) {
      toast.error(
        `Ocurrió un error al intentar subir el archivo ${file?.name}`
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async (
    key: typeFile,
    userId: number | string,
    approvalId?: string
  ) => {
    setIsLoading(true);
    try {
      const response: any = await getPresignedS3Service(
        key,
        String(userId),
        getName(key, Boolean(approvalId)),
        "",
        "get_object",
        approvalId
      );
      // Soporta respuestas antiguas (solo urls) y nuevas (urls + keys)
      const urls: string[] = Array.isArray(response) ? response : response?.data || response;
      const keys: string[] | undefined = response?.keys;
      
      // Retornar el objeto con urls y keys (incluso si están vacíos)
      return { urls: urls || [], keys: keys || [] };
    } catch (error) {
      // No mostrar toast de error, solo loguear
      // El componente que llama decidirá si mostrar un error o no
      console.error('Error al obtener adjuntos:', error);
      return { urls: [], keys: [] };
    } finally {
      setIsLoading(false);
    }
  };

  return { handleUpload, handleDownload, isLoading };
};

export default useFileUpload;

const getName = (key: string, hasApproval = false) => {
  switch (key) {
    case "documents":
      return "1";

    case "brand_models":
      return "brand_models_info"; // Devuelve directamente el subdirectorio correcto para brand_models

    default:
      return hasApproval ? "approval" : "images";
  }
};

const getType = (type: string) => type.split("/")[1];

